<template>
    <div>
        <div class="card-body text-center">
            <div class="button-group">
                <button @click="confirmContract" class="btn btn-primary" type="button">Confirm</button>
                <button @click="voidContract" class="btn btn-secondary" type="button">Void</button>
            </div>
        </div>
        <div class="card-body">
            <p class="text-center aboutscroll">
                If everything is ok then the contract can be in confirm state and the contract will be considered as a valid contract, otherwise you can void.
            </p>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "MarketplaceContractConfirm",
        props: ["contractid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        methods: {
            async confirmContract() {
                await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/contracts/${this.contractid}/confirm`, {
                    comments: ''
                });
                this.$root.$emit('refreshContract');
                this.$toastr('success', 'Contract status updated successfully', 'Contract Updation');
            },
            async voidContract() {
                await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/contracts/${this.contractid}/void`);
                this.$root.$emit('refreshContract');
                this.$toastr('success', 'Contract status updated successfully', 'Contract Deletion');
            }
        }
    }
</script>

<style scoped>

</style>
